import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BrowseThumbLayout from '../../../BrowseThumbLayout';
import ContentLoader from '../../../ContentLoader';
import Strips from '../../../Strips';
import OrderDropdown from '../../_partials/OrderDropdown';
import BasePageLayout from '../../_partials/BasePageLayout';
import SearchPageHeader from '../../../SearchPageHeader';
import s from './SearchPage.scss';

export interface Props {
  searchType?: string;
  hasOrderSubnav?: boolean;
  initialOffset?: number;
}

const SearchPage: React.FC<Props> = ({
  hasOrderSubnav,
  initialOffset,
  searchType,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <BasePageLayout
      headerRightSideContent={hasOrderSubnav && !isMobile && <OrderDropdown />}
      withNetworkBar={false}
    >
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {isMobile && (
        <div className={s['order-dropdown']}>
          <OrderDropdown />
        </div>
      )}
      <BiLoggerContextProvider
        value={{
          sectionname: 'general',
          _rankOffset: initialOffset,
        }}
      >
        <Strips areTopStrips />
        <ContentLoader>
          {searchType === 'all' && <SearchPageHeader />}
          <BrowseThumbLayout />
        </ContentLoader>
      </BiLoggerContextProvider>
    </BasePageLayout>
  );
};
SearchPage.displayName = 'SearchPage';

export default SearchPage;
